export default __webpack_public_path__ + "static/media/mapaCelular.d374eb37.png";